import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const Breadcrumb = ({ items = [], current }) => (
  <Container aria-label="breadcrumb">
    {items.map(({ label, to }) => (
      <React.Fragment key={to}>
        <Crumb to={to}>{label}</Crumb>
        <Separator>/</Separator>
      </React.Fragment>
    ))}
    <Current>{current}</Current>
  </Container>
);

const Container = styled.div`
  grid-column: 2/3;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.375rem;
  margin-bottom: 1.5rem;
  font-size: 0.875rem;

  @media print {
    display: none;
  }
`;

const Crumb = styled(Link)`
  font-weight: 600;
  color: var(--ax-mid, #5c5c5c);
  text-decoration: none;

  &:hover {
    color: var(--ax-black);
  }
`;

const Separator = styled.span`
  color: var(--ax-mid, #5c5c5c);
`;

const Current = styled.span`
  font-weight: 600;
  color: var(--ax-black);
`;

export default Breadcrumb;
